import Axios from 'axios'
import { getPathName, getApiHash, getApiToken } from './helper';

const subirArchivo = async (nombre: string, extension: string, dataBase64: string, idPoliza: number) => {
    const params = {
        hash: await getApiHash(),
        idPoliza: idPoliza,
        archivo:
        {
            nombre: nombre,
            extension: extension,
            dataBase64: dataBase64
        }

    }
    const headers = {
        'content-type': 'application/json',
        "Authorization": 'Bearer ' + await getApiToken()
    }
    return await Axios.post(await getPathName() + "/SetCertificadoNoRodamiento", params,
        {
            headers: headers
        }).then(function (response) {
            return response.data;
        }).catch(function (error) {
            return error;
        });
};

export default subirArchivo;